import React from 'react';
import PropTypes from 'prop-types';
import { FaExclamationCircle } from 'react-icons/fa';
import { useColors } from '../../../hooks/useColors';
import { useTextReplacement } from '../../../hooks/useTextReplacement';
import { ActionButton } from '../forms';

/**
 * ErrorMessage component for displaying error messages with optional retry
 * Uses semantic styling and configuration support
 */
const ErrorMessage = ({ message, className = '', onRetry }) => {
  const colors = useColors();
  const semantic = colors.semantic;
  const { replace } = useTextReplacement();

  // Don't render if no message
  if (!message) {
    return null;
  }

  return (
    <div className={`text-center py-8 px-4 ${semantic.contentCardBg} ${semantic.contentCardBorder} rounded-lg ${className}`}>
      <FaExclamationCircle className={`mx-auto text-red-500 dark:text-red-400 text-4xl mb-4`} />
      <p className={`${semantic.contentCardText} mb-4`}>
        {replace(message)}
      </p>
      {onRetry && (
        <ActionButton
          action="refresh"
          onClick={onRetry}
          title="Try Again"
          showText={true}
          size="md"
          className="px-4 py-2"
        />
      )}
    </div>
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
  onRetry: PropTypes.func
};

export default ErrorMessage;

